import React from 'react';
import loadable from '@loadable/component';
import LoadingScreen from 'components/LoadingScreen';

const LoadablePrequalOfferApplication = loadable(
  () => import('./PrequalOfferApplication'),
  {
    fallback: <LoadingScreen />,
  },
);

export const PrequalOfferApplicationPending = loadable(
  () => import('./Pending'),
  {
    fallback: <LoadingScreen />,
  },
);

export const PrequalOfferApplicationError = loadable(() => import('./Error'), {
  fallback: <LoadingScreen />,
});

export const PrequalOfferApplicationNotQualified = loadable(
  () => import('./NotQualified'),
  {
    fallback: <LoadingScreen />,
  },
);

export const PrequalOfferApplicationExistingPreapproval = loadable(
  () => import('./ExistingPreapproval'),
  {
    fallback: <LoadingScreen />,
  },
);

export default LoadablePrequalOfferApplication;
